import React, { useEffect, useMemo, useState } from "react";
import "./Jewellery.css";
import { Link, useSearchParams } from "react-router-dom";
import Pagination from "../components/Pagination";
import { getAllSupabaseProducts, getJewellerySubCategories, getAllJewellerySubSubCategories } from "../lib/productService";
import { useCartWishlist } from "../contexts/CartWishlistContext";
import { PRODUCTS } from "../data/products";

/* Earrings */
import eStud1 from "../assets/stud1.jpeg";
import eStud2 from "../assets/stud2.jpeg";
import eStud3 from "../assets/stud3.jpeg";
import eStud4 from "../assets/stud4.jpg";

/* Monalisa (6) */
import eMona1 from "../assets/monalisa1.jpeg";
import eMona2 from "../assets/monalisa2.jpeg";
import eMona3 from "../assets/monalisa3.jpeg";
import eMona4 from "../assets/monalisa4.jpeg";
import eMona5 from "../assets/monalisa5.jpeg";
import eMona6 from "../assets/monalisa6.jpeg";

/* Hoops (ONLY 1) */
import eHoop1 from "../assets/hoop1.jpeg";

/* Necklace / Pendant (existing) */
import nPendant1 from "../assets/pendant1.jpeg";
import nPendant2 from "../assets/pendant2.jpeg";
import nPendant3 from "../assets/pendant3.jpeg";
import nPendant4 from "../assets/pendant4.jpeg";
import nPendant5 from "../assets/pendant5.jpeg";
import nPendant6 from "../assets/pendant6.jpeg";
import nPendant7 from "../assets/pendant7.jpeg";
import nPendant8 from "../assets/pendant8.jpeg";

/* Chokers */
import nChoker1 from "../assets/choker1.jpg";
import nChoker2 from "../assets/choker2.jpg";
import nChoker3 from "../assets/choker3.jpg";

/* Matching Set */
import nSet1 from "../assets/matching1.jpg";

/* American Diamond Stone Necklace (12 images) */
import adGold1 from "../assets/ad-gold1.jpg";
import adGold2 from "../assets/ad-gold2.jpg";
import adGold3 from "../assets/ad-gold3.jpg";
import adGold4 from "../assets/ad-gold4.jpg";
import adGold5 from "../assets/ad-gold5.jpg";
import adGold6 from "../assets/ad-gold6.jpg";

import adSilver1 from "../assets/ad-silver1.jpg";
import adSilver2 from "../assets/ad-silver2.jpg";
import adSilver3 from "../assets/ad-silver3.jpg";
import adSilver4 from "../assets/ad-silver4.jpg";
import adSilver5 from "../assets/ad-silver5.jpg";
import adSilver6 from "../assets/ad-silver6.jpg";

/* ✅ CZ Stone Necklaces (NEW) */
import czGold1 from "../assets/cz1.jpg";
import czGold2 from "../assets/cz2.jpg";
import czGold3 from "../assets/cz3.jpg";
import czGold4 from "../assets/cz4.jpg";

import czSilver1 from "../assets/cz-silver1.jpg";
import czSilver2 from "../assets/cz-silver2.jpg";

import czCircle1 from "../assets/ad-circle1.jpg";
import czCircle2 from "../assets/ad-circle2.jpg";

/* Bracelets */
import brGold1 from "../assets/gold-bracelet1.jpeg";
import brGold2 from "../assets/gold-bracelet2.jpeg";
import brGold3 from "../assets/gold-bracelet3.jpeg";
import brGold4 from "../assets/gold-bracelet4.jpeg";

import brKada1 from "../assets/kada1.jpeg";
import brKada2 from "../assets/kada2.jpeg";
import brKada3 from "../assets/kada3.jpg";
import brKada4 from "../assets/kada4.jpeg";

import brCuff1 from "../assets/cuff-bracelet1.jpeg";
import brCuff2 from "../assets/cuff-bracelet2.jpeg";
import brCuff3 from "../assets/cuff-bracelet3.jpeg";

/* Bangles */
import baAnti1 from "../assets/anti-tarnish-bangle1.jpeg";
import baBrass1 from "../assets/brass-gold-bangle1.jpeg";
import baBrass2 from "../assets/brass-gold-bangle2.jpeg";
import baFancy1 from "../assets/unique-bangle1.jpeg";

/* Ring */
import ring1 from "../assets/ring1.jpeg";

const formatINR = (amount) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(amount);

/* ✅ Price Rules (MRP + Offer) */
const getMrpForItem = ({ cat, sub, sectionTitle, czGroupTitle, itemId }) => {
  // Earrings
  if (cat === "earrings") {
    if (sub === "Hoops") return 199; // hoops original
    return 249; // all other earrings original
  }

  // Necklace
  if (cat === "necklace") {
    if (sub === "Pendant Necklaces") return 249;
    if (sub === "American Diamond Stone Necklaces") return 999;
    if (sub === "Choker Necklaces") return 1999;
    if (sub === "Matching Necklace + Earrings Sets") return 999;

    // CZ Section
    if (sectionTitle === "CZ Stone Necklaces") {
      const isCircle =
        (czGroupTitle || "").toLowerCase().includes("circle") ||
        (itemId || "").includes("cz-circle");
      if (isCircle) return 999; // american circle
      return 1499; // all other CZ
    }
  }

  // Bracelets
  if (cat === "bracelets") {
    if ((sub || "").toLowerCase().includes("cuff")) return 399; // cuff original
    return 499; // other bracelets
  }

  // Bangles
  if (cat === "bangles") return 399;

  // Rings
  if (cat === "rings") return 199;

  return null;
};

/* ✅ Dynamic User Ratings */
const getRatingReviews = (id, override = null) => {
  if (override && override.rating !== undefined) {
    return { rating: Number(override.rating) || 0, reviews: Number(override.review_count) || 0 };
  }
  const savedRating = localStorage.getItem(`rating:${id}`);
  if (savedRating) {
    return { rating: Number(savedRating), reviews: 1 };
  }
  return { rating: 0, reviews: 0 };
};

/* ✅ Bestseller rules (exact as user list) */
const BESTSELLER_IDS = new Set([
  // Bangles (all)
  "ba-anti-1",
  "ba-brass-1",
  "ba-brass-2",
  "ba-fancy-1",

  // Rings (all)
  "ring-1",

  // Earrings: all Monalisa
  "e-mona-1",
  "e-mona-2",
  "e-mona-3",
  "e-mona-4",
  "e-mona-5",
  "e-mona-6",

  // Earrings: Studs (1,3)
  "stud-1",
  "stud-3",

  // Earrings: Hoops
  "e-hoop-1",

  // Bracelets: Gold (1,3,4)
  "br-gold-1",
  "br-gold-3",
  "br-gold-4",

  // Bracelets: Kada (3,4)
  "br-kada-3",
  "br-kada-4",

  // Bracelets: Cuff (1,3)
  "br-cuff-1",
  "br-cuff-3",

  // Necklace: Pendants (2,5,6,8)
  "n-pendant-2",
  "n-pendant-5",
  "n-pendant-6",
  "n-pendant-8",

  // American Diamond Stone Necklaces
  // gold plated -> 1,3,5
  "ad-gold-1",
  "ad-gold-3",
  "ad-gold-5",

  // silver plated -> 2,3,6
  "ad-silver-2",
  "ad-silver-3",
  "ad-silver-6",

  //chokers
  "choker-1",

  //ad-circles
  "cz-circle-1",
]);

const isBestseller = ({ item, secTitle, czGroupTitle }) => {
  if (item.isBestseller) return true;
  if (BESTSELLER_IDS.has(item.id)) return true;

  // ✅ CZ: gold group ALL + silver group ALL
  if (secTitle === "CZ Stone Necklaces") {
    const t = (czGroupTitle || "").toLowerCase();
    if (t.includes("gold tone")) return true;
    if (t.includes("silver tone")) return true;
  }

  return false;
};

export default function Jewellery() {
  const [searchParams] = useSearchParams();

  const baseCategories = useMemo(
    () => [
      { key: "all", label: "All" },
      { key: "earrings", label: "Earrings" },
      { key: "necklace", label: "Necklace" },
      { key: "bracelets", label: "Bracelets" },
      { key: "bangles", label: "Bangles" },
      { key: "rings", label: "Rings" },
    ],
    []
  );

  const [dashboardSubCategories, setDashboardSubCategories] = useState([]);
  const [dbSubSubCategories, setDbSubSubCategories] = useState({}); // { "Necklaces": [{ name, id }, ...], ... }
  useEffect(() => {
    getJewellerySubCategories().then((names) => {
      const existing = new Set(baseCategories.map((c) => c.label.toLowerCase()));
      // Avoid duplicate: "Necklace" (base) and "Necklaces" (DB) are the same
      if (existing.has("necklace")) existing.add("necklaces");
      if (existing.has("necklaces")) existing.add("necklace");
      const extra = (names || [])
        .filter((n) => !existing.has(n.toLowerCase()))
        .map((n) => ({ key: n.toLowerCase().replace(/\s+/g, "-"), label: n }));
      setDashboardSubCategories(extra);
    });
  }, [baseCategories]);
  useEffect(() => {
    getAllJewellerySubSubCategories().then(setDbSubSubCategories);
  }, []);

  const categories = useMemo(
    () => [...baseCategories, ...dashboardSubCategories],
    [baseCategories, dashboardSubCategories]
  );

  const catalog = useMemo(
    () => ({
      earrings: [
        {
          title: "Monalisa",
          items: [
            {
              id: "e-mona-1",
              cat: "earrings",
              sub: "Monalisa",
              img: eMona1,
              name: "AYRINE elegant water drop Mona Lisa earrings",
              price: 119,
              link: "/monalisa-1",
            },
            {
              id: "e-mona-2",
              cat: "earrings",
              sub: "Monalisa",
              img: eMona2,
              name: "AYRINE white shiny shell pearl Mona Lisa earrings",
              price: 119,
              link: "/monalisa-2",
            },
            {
              id: "e-mona-3",
              cat: "earrings",
              sub: "Monalisa",
              img: eMona3,
              name: "YRINE gold pearl studded Mona Lisa earrings",
              price: 119,
              link: "/monalisa-3",
            },
            {
              id: "e-mona-4",
              cat: "earrings",
              sub: "Monalisa",
              img: eMona4,
              name: "AYRINE off white drop Mona Lisa earrings",
              price: 119,
              link: "/monalisa-4",
            },
            {
              id: "e-mona-5",
              cat: "earrings",
              sub: "Monalisa",
              img: eMona5,
              name: "AYRINE gold plated Mona Lisa earrings",
              price: 119,
              link: "/monalisa-5",
            },
            {
              id: "e-mona-6",
              cat: "earrings",
              sub: "Monalisa",
              img: eMona6,
              name: "AYRINE indo western gold Mona Lisa earrings",
              price: 119,
              link: "/monalisa-6",
            },
          ],
        },
        {
          title: "Studs",
          items: [
            {
              id: "stud-1",
              cat: "earrings",
              sub: "Studs",
              img: eStud1,
              name: "AYRINE combo of 3 pair gold plated hoop earrings",
              price: 149,
              link: "/stud-1",
            },
            {
              id: "stud-2",
              cat: "earrings",
              sub: "Studs",
              img: eStud2,
              name: "AYRINE combo of 3 pair heart dolphin earrings",
              price: 149,
              link: "/stud-2",
            },
            {
              id: "stud-3",
              cat: "earrings",
              sub: "Studs",
              img: eStud3,
              name: "AYRINE combo of 3 pair sea shell-swan earrings",
              price: 149,
              link: "/stud-3",
            },
            {
              id: "stud-4",
              cat: "earrings",
              sub: "Studs",
              img: eStud4,
              name: "AYRINE combo of 3 pair star & flur earrings",
              price: 149,
              link: "/stud-4",
            },
          ],
        },
        {
          title: "Hoops",
          items: [
            {
              id: "e-hoop-1",
              cat: "earrings",
              sub: "Hoops",
              img: eHoop1,
              name: "AYRINE Twisted gold style big hoop earrings",
              price: 99,
              link: "/hoop-1",
            },
          ],
        },
      ],

      necklace: [
        {
          title: "Pendant Necklaces",
          items: [
            {
              id: "n-pendant-1",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant1,
              name: "AYRINE vintage natural diamond chain-pendant",
              price: 149,
              link: "/necklace-pendant-1",
            },
            {
              id: "n-pendant-2",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant2,
              name: "AYRINE popping heart zircon diamond chain-pendant",
              price: 149,
              link: "/necklace-pendant-2",
            },
            {
              id: "n-pendant-3",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant3,
              name: "AYRINE Bow cute butterfly chain-pendant",
              price: 149,
              link: "/necklace-pendant-3",
            },
            {
              id: "n-pendant-4",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant4,
              name: "AYRINE gold bow cute diamond tie chain-pendant",
              price: 149,
              link: "/necklace-pendant-4",
            },
            {
              id: "n-pendant-5",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant5,
              name: "AYRINE crystal clover chain-pendant",
              price: 149,
              link: "/necklace-pendant-5",
            },
            {
              id: "n-pendant-6",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant6,
              name: "AYRINE cute gold doubled heart chain pendant",
              price: 149,
              link: "/necklace-pendant-6",
            },
            {
              id: "n-pendant-7",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant7,
              name: "AYRINE emerald diamond flurr chain pendant",
              price: 149,
              link: "/necklace-pendant-7",
            },
            {
              id: "n-pendant-8",
              cat: "necklace",
              sub: "Pendant Necklaces",
              img: nPendant8,
              name: "AYRINE diamond butterfly chain pendant",
              price: 149,
              link: "/necklace-pendant-8",
            },
          ],
        },

        {
          title: "American Diamond Stone Necklaces",
          items: [
            {
              id: "ad-gold-1",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adGold1,
              name: "AYRINE trending AD stone purple gold plated necklace",
              price: 699,
              link: "/ad-gold-1",
            },
            {
              id: "ad-gold-2",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adGold2,
              name: "AYRINE trending AD stone pink gold plated necklace",
              price: 699,
              link: "/ad-gold-2",
            },
            {
              id: "ad-gold-3",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adGold3,
              name: "AYRINE trending AD stone baby pink gold plated necklace ",
              price: 699,
              link: "/ad-gold-3",
            },
            {
              id: "ad-gold-4",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adGold4,
              name: "AYRINE trending AD stone blue gold plated necklace",
              price: 699,
              link: "/ad-gold-4",
            },
            {
              id: "ad-gold-5",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adGold5,
              name: "AYRINE trending AD stone white gold plated necklace",
              price: 699,
              link: "/ad-gold-5",
            },
            {
              id: "ad-gold-6",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adGold6,
              name: "AYRINE trending AD stone black gold plated necklace",
              price: 699,
              link: "/ad-gold-6",
            },

            {
              id: "ad-silver-1",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adSilver1,
              name: "AYRINE trending AD stone blue silver plated necklace",
              price: 699,
              link: "/ad-silver-1",
            },
            {
              id: "ad-silver-2",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adSilver2,
              name: "AYRINE trending AD stone green silver plated necklace",
              price: 699,
              link: "/ad-silver-2",
            },
            {
              id: "ad-silver-3",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adSilver3,
              name: "AYRINE trending AD baby pink silver plated necklace ",
              price: 699,
              link: "/ad-silver-3",
            },
            {
              id: "ad-silver-4",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adSilver4,
              name: "AYRINE trending AD stone pink silver plated necklace",
              price: 699,
              link: "/ad-silver-4",
            },
            {
              id: "ad-silver-5",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adSilver5,
              name: "AYRINE trending AD stone white silver plated necklace",
              price: 699,
              link: "/ad-silver-5",
            },
            {
              id: "ad-silver-6",
              cat: "necklace",
              sub: "American Diamond Stone Necklaces",
              img: adSilver6,
              name: "AYRINE trending AD stone black silver plated necklace ",
              price: 699,
              link: "/ad-silver-6",
            },
          ],
        },

        {
          title: "Choker Necklaces",
          items: [
            {
              id: "choker-1",
              cat: "necklace",
              sub: "Choker Necklaces",
              img: nChoker1,
              name: "AYRINE Victorian pearl choker set",
              price: 1499,
              link: "/choker-1",
            },
            {
              id: "choker-2",
              cat: "necklace",
              sub: "Choker Necklaces",
              img: nChoker2,
              name: "AYRINE green Kundan white beads choker set",
              price: 1499,
              link: "/choker-2",
            },
            {
              id: "choker-3",
              cat: "necklace",
              sub: "Choker Necklaces",
              img: nChoker3,
              name: "AYRINE Elegant fresh water pearl choker set",
              price: 1499,
              link: "/choker-3",
            },
          ],
        },

        {
          title: "Matching Necklace + Earrings Sets",
          items: [
            {
              id: "n-set-1",
              cat: "necklace",
              sub: "Matching Necklace + Earrings Sets",
              img: nSet1,
              name: "Noor Matching Set",
              price: 799,
              link: "/n-set-1",
            },
          ],
        },

        /* ✅ ===================== CZ SECTION ===================== */
        {
          title: "CZ Stone Necklaces",
          variant: "cz",
          groups: [
            {
              title: "Gold tone flower design CZ",
              desc:
                "Warm gold tone with floral sparkle — perfect for festive + daily glam.",
              items: [
                {
                  id: "cz-gold-1",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czGold1,
                  name: "AYRINE Gold tone flower CZ necklace",
                  price: 1099,
                  link: "/cz-gold-1",
                },
                {
                  id: "cz-gold-2",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czGold2,
                  name: "AYRINE Gold bloom CZ pendant necklace",
                  price: 1099,
                  link: "/cz-gold-2",
                },
                {
                  id: "cz-gold-3",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czGold3,
                  name: "AYRINE Floral CZ stone chain necklace (Gold)",
                  price: 1099,
                  link: "/cz-gold-3",
                },
                {
                  id: "cz-gold-4",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czGold4,
                  name: "AYRINE Petal shine CZ necklace (Gold tone)",
                  price: 1099,
                  link: "/cz-gold-4",
                },
              ],
            },
            {
              title: "Silver tone flower design CZ",
              desc:
                "Cool silver sparkle with delicate flower design — elegant & minimal.",
              items: [
                {
                  id: "cz-silver-1",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czSilver1,
                  name: "AYRINE Silver tone flower CZ necklace",
                  price: 1099,
                  link: "/cz-silver-1",
                },
                {
                  id: "cz-silver-2",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czSilver2,
                  name: "AYRINE Silver floral CZ chain necklace",
                  price: 1099,
                  link: "/cz-silver-2",
                },
              ],
            },
            {
              title: "American Diamond circle design necklace",
              desc:
                "Classic circle motif with diamond-like shine — timeless and premium.",
              items: [
                {
                  id: "cz-circle-1",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czCircle1,
                  name: "AYRINE American Diamond circle necklace",
                  price: 749,
                  link: "/cz-circle-1",
                },
                {
                  id: "cz-circle-2",
                  cat: "necklace",
                  sub: "CZ Stone Necklaces",
                  img: czCircle2,
                  name: "AYRINE Circular AD pendant necklace",
                  price: 749,
                  link: "/cz-circle-2",
                },
              ],
            },
          ],
        },
        /* ✅ ========================================================= */
      ],

      bracelets: [
        {
          title: "Gold Bracelets",
          items: [
            {
              id: "br-gold-1",
              cat: "bracelets",
              sub: "Gold Bracelets",
              img: brGold1,
              name: "AYRINE jewellery Style craft butterfly bracelet for girls",
              price: 249,
              link: "/gold-bracelet-1",
            },
            {
              id: "br-gold-2",
              cat: "bracelets",
              sub: "Gold Bracelets",
              img: brGold2,
              name: "AYRINE Bubble style gold tone bracelet",
              price: 249,
              link: "/gold-bracelet-2",
            },
            {
              id: "br-gold-3",
              cat: "bracelets",
              sub: "Gold Bracelets",
              img: brGold3,
              name: "AYRINE Black clover bracelet for party wear",
              price: 249,
              link: "/gold-bracelet-3",
            },
            {
              id: "br-gold-4",
              cat: "bracelets",
              sub: "Gold Bracelets",
              img: brGold4,
              name: "AYRINE Gold plated Nail bracelet for girls",
              price: 199,
              link: "/gold-bracelet-4",
            },
          ],
        },
        {
          title: "Gold Kada",
          items: [
            {
              id: "br-kada-1",
              cat: "bracelets",
              sub: "Gold Kada",
              img: brKada1,
              name: "AYRINE Ocean curve gold plated kada/cuff",
              price: 249,
              link: "/gold-kada-1",
            },
            {
              id: "br-kada-2",
              cat: "bracelets",
              sub: "Gold Kada",
              img: brKada2,
              name: "AYRINE round golden kada for girls & women’s",
              price: 219,
              link: "/gold-kada-2",
            },
            {
              id: "br-kada-3",
              cat: "bracelets",
              sub: "Gold Kada",
              img: brKada3,
              name: "AYRINE Gold pleated cuff kada for girls",
              price: 299,
              link: "/gold-kada-3",
            },
            {
              id: "br-kada-4",
              cat: "bracelets",
              sub: "Gold Kada",
              img: brKada4,
              name: "AYRINE 5 layer flexible stretch coil bracelet",
              price: 149,
              link: "/gold-kada-4",
            },
          ],
        },
        {
          title: "Cuff Bracelets",
          items: [
            {
              id: "br-cuff-1",
              cat: "bracelets",
              sub: "Cuff Bracelets",
              img: brCuff1,
              name: "AYRINE Geometric gold spiral cuff kada",
              price: 149,
              link: "/cuff-bracelet-1",
            },
            {
              id: "br-cuff-2",
              cat: "bracelets",
              sub: "Cuff Bracelets",
              img: brCuff2,
              name: "AYRINE wraparound bracelet",
              price: 149,
              link: "/cuff-bracelet-2",
            },
            {
              id: "br-cuff-3",
              cat: "bracelets",
              sub: "Cuff Bracelets",
              img: brCuff3,
              name:
                "AYRINE Gold toned multi layered bracelet & bangle for women’s & girls",
              price: 149,
              link: "/cuff-bracelet-3",
            },
          ],
        },
      ],

      bangles: [
        {
          title: "Anti-Tarnish Gold Plated Bangles",
          items: [
            {
              id: "ba-anti-1",
              cat: "bangles",
              sub: "Anti-Tarnish Gold Plated Bangles",
              img: baAnti1,
              name: "AYRINE golden brass imitation dailywear bangles",
              price: 199,
              link: "/bangle-anti-1",
            },
          ],
        },
        {
          title: "Brass Gold Bangles",
          items: [
            {
              id: "ba-brass-1",
              cat: "bangles",
              sub: "Brass Gold Bangles",
              img: baBrass1,
              name: "AYRINE Delicate Australian stone Bangles",
              price: 249,
              link: "/bangle-brass-1",
            },
            {
              id: "ba-brass-2",
              cat: "bangles",
              sub: "Brass Gold Bangles",
              img: baBrass2,
              name: "AYRINE Brass kadli design dailywear bangles",
              price: 249,
              link: "/bangle-brass-2",
            },
          ],
        },
        {
          title: "Unique Fancy Bangles",
          items: [
            {
              id: "ba-fancy-1",
              cat: "bangles",
              sub: "Unique Fancy Bangles",
              img: baFancy1,
              name: "AYRINE fancy fine work premium bangles",
              price: 249,
              link: "/bangle-fancy-1",
            },
          ],
        },
      ],

      rings: [
        {
          title: "Rings",
          items: [
            {
              id: "ring-1",
              cat: "rings",
              sub: "Rings",
              img: ring1,
              name: "AYRINE love ring with 3 diamonds, Anti-tarnish & waterproof",
              price: 99,
              link: "/ring-1",
            },
          ],
        },
      ],
    }),
    []
  );

  // ✅ Category filter
  const [active, setActive] = useState("all");

  // Dashboard products from Supabase (exclude duplicates of static catalog)
  const staticTitles = useMemo(() => new Set(Object.values(PRODUCTS).map((p) => p.title)), []);
  const [managedProducts, setManagedProducts] = useState([]);
  const [supabaseMap, setSupabaseMap] = useState({});

  useEffect(() => {
    getAllSupabaseProducts().then((list) => {
      const map = {};
      list.forEach((p) => {
        if (p.title) map[p.title.trim().toLowerCase()] = p;
      });
      setSupabaseMap(map);

      const filtered = list.filter((p) => !staticTitles.has(p.title.trim()));
      setManagedProducts(
        filtered.map((p) => ({
          id: p.id,
          name: p.title,
          price: p.offerPrice,
          img: p.images?.[0],
          link: `/product/${p.slug || p.id}`,
          cat: "managed",
          sub: p.category || "Managed",
          isBestseller: p.isBestseller,
        }))
      );
    });
  }, [staticTitles]);

  useEffect(() => {
    const cat = searchParams.get("cat");
    const allowed = new Set(categories.map((c) => c.key));
    if (cat && allowed.has(cat)) setActive(cat);
  }, [searchParams, categories]);

  // Map UI label to DB sub-category name (Necklace -> Necklaces)
  const labelToDbName = useMemo(() => ({
    Necklace: "Necklaces", Earrings: "Earrings", Bracelets: "Bracelets", Bangles: "Bangles", Rings: "Rings",
  }), []);

  const groupsToRender = useMemo(() => {
    const order = ["earrings", "necklace", "bracelets", "bangles", "rings"];
    const allKeys = [...order, ...dashboardSubCategories.map((c) => c.key)];

    const buildSections = (key, categoryLabel) => {
      const baseSections = catalog[key] || [];
      const dbName = labelToDbName[categoryLabel] || categoryLabel;
      const dbSubSubs = dbSubSubCategories[dbName] || [];
      const dbSections = dbSubSubs.map((c) => ({
        title: c.name,
        items: [],
        isSubSub: true,
      }));
      return [...baseSections, ...dbSections];
    };

    if (active === "all") {
      return allKeys.map((key) => {
        const categoryLabel = categories.find((c) => c.key === key)?.label ?? key;
        return {
          categoryKey: key,
          categoryLabel,
          sections: buildSections(key, categoryLabel),
        };
      });
    }

    const categoryLabel = categories.find((c) => c.key === active)?.label ?? active;
    return [
      {
        categoryKey: active,
        categoryLabel,
        sections: buildSections(active, categoryLabel),
      },
    ];
  }, [active, catalog, categories, dashboardSubCategories, dbSubSubCategories, labelToDbName]);

  const PER_PAGE = 12;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // We intentionally do not smooth scroll here to avoid conflicting with instant pagination scroll
  }, [active]);

  const allItemsFlat = useMemo(() => {
    const out = [];
    groupsToRender.forEach((group) => {
      const groupManaged = managedProducts.filter((p) => p.sub === group.categoryLabel);
      if (group.sections.length === 0 && groupManaged.length > 0) {
        groupManaged.forEach((item) => out.push({ item, secTitle: group.categoryLabel, czGroupTitle: null }));
      }
      group.sections.forEach((sec) => {
        if (sec.title === "CZ Stone Necklaces" && sec.groups) {
          sec.groups.forEach((g) => {
            g.items.forEach((item) => out.push({ item, secTitle: sec.title, czGroupTitle: g.title }));
          });
        } else if (sec.isSubSub) {
          const subSubItems = managedProducts.filter((p) => p.sub === sec.title);
          subSubItems.forEach((item) => out.push({ item, secTitle: sec.title, czGroupTitle: null }));
        } else if (sec.items) {
          sec.items.forEach((item) => out.push({ item, secTitle: sec.title, czGroupTitle: null }));
        }
      });
    });
    if (active === "all" && managedProducts.length > 0) {
      const byCategory = managedProducts.reduce((acc, item) => {
        const cat = item.sub && item.sub !== "Managed" ? item.sub : "From Our Collection";
        if (!acc[cat]) acc[cat] = [];
        acc[cat].push(item);
        return acc;
      }, {});
      const inFilterTabs = (name) => groupsToRender.some((g) => g.categoryLabel === name);
      const extraCats = Object.entries(byCategory).filter(([cat]) => !inFilterTabs(cat));
      extraCats.forEach(([, items]) => {
        items.forEach((item) => out.push({ item, secTitle: "From Our Collection", czGroupTitle: null }));
      });
    }
    return out;
  }, [groupsToRender, managedProducts, active]);

  const paginatedItems = useMemo(() => {
    const start = (currentPage - 1) * PER_PAGE;
    return allItemsFlat.slice(start, start + PER_PAGE);
  }, [allItemsFlat, currentPage]);

  const totalPages = Math.ceil(allItemsFlat.length / PER_PAGE) || 1;

  // Group paginated items by section (sub-sub category) for headings
  const itemsBySection = useMemo(() => {
    const groups = [];
    let lastSec = null;
    paginatedItems.forEach(({ item, secTitle, czGroupTitle }) => {
      if (secTitle !== lastSec) {
        groups.push({ secTitle, items: [] });
        lastSec = secTitle;
      }
      groups[groups.length - 1].items.push({ item, secTitle, czGroupTitle });
    });
    return groups;
  }, [paginatedItems]);

  useEffect(() => {
    setCurrentPage(1);
  }, [active, allItemsFlat.length]);



  // ✅ CART & WISHLIST from Supabase
  const {
    addToCart,
    incQty,
    decQty,
    getQty,
    toggleWish,
    isWished,
  } = useCartWishlist();

  const renderCard = ({ item, secTitle, czGroupTitle }) => {
    const override = supabaseMap[item.name?.trim().toLowerCase()];
    const displayPrice = override ? override.offerPrice : item.price;
    const displayName = override ? override.title : item.name;
    const displayImg = override?.images?.[0] || item.img;

    const qty = getQty(item.id);

    const { rating, reviews } = getRatingReviews(item.id, override);

    const mrp = getMrpForItem({
      cat: item.cat,
      sub: item.sub,
      sectionTitle: secTitle,
      czGroupTitle,
      itemId: item.id,
    });

    const showBestseller = isBestseller({ item, secTitle, czGroupTitle }) || override?.isBestseller;
    const wished = isWished(item.id);
    
    return (
      <Link 
        to={item.link ? (item.link.startsWith('/product') ? item.link : `/product${item.link.startsWith('/') ? '' : '/'}${item.link}`) : "#"} 
        state={{ product: { title: displayName, offerPrice: displayPrice, img: displayImg, ...override } }} 
        className="pCardLink" 
        key={item.id}
      >
        <article className="pCard" tabIndex={0}>
          <div className="pMedia">
            {showBestseller && <div className="pRibbon">Bestseller</div>}

            <button
              className={`pWishMedia ${wished ? "active" : ""}`}
              aria-label={wished ? "Remove from wishlist" : "Add to wishlist"}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleWish(item);
              }}
            >
              {wished ? "♥" : "♡"}
            </button>

            <img
              className="pImg"
              src={displayImg}
              alt={displayName}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect fill='%23f3f3f3' width='200' height='200'/%3E%3Ctext fill='%23999' font-size='12' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3ENo Image%3C/text%3E%3C/svg%3E";
              }}
            />

            <div className="pRatingPill">
              <span className="pRatingNum">{rating.toFixed(1)}</span>
              <span className="pStar">★</span>
              <span className="pRatingSep">|</span>
              <span className="pRatingCount">{formatINR(reviews)}</span>
            </div>
          </div>

          <div className="pInfo">
            <h3 className="pName">{displayName}</h3>

            <div className="pMeta">
              <div className="pPriceStack">
                <div className="pOffer">₹{formatINR(displayPrice)}</div>
                {mrp ? <div className="pMrp">₹{formatINR(mrp)}</div> : null}
              </div>
            </div>

            {qty === 0 ? (
              <button
                className="pAddCart"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  addToCart(item);
                }}
              >
                Add to Cart
              </button>
            ) : (
              <div
                className="pQtyWrap"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <button
                  className="pQtyBtn"
                  type="button"
                  aria-label="Decrease quantity"
                  onClick={() => decQty(item.id)}
                >
                  −
                </button>

                <span className="pQtyNum">{qty}</span>

                <button
                  className="pQtyBtn"
                  type="button"
                  aria-label="Increase quantity"
                  onClick={() => incQty(item.id)}
                >
                  +
                </button>
              </div>
            )}
          </div>
        </article>
      </Link>
    );
  };

  return (
    <div className="jewelleryPage">
      <section className="jSection">
        <div className="jWrap">
          <h2 className="jTitle">Our Jewellery Collection</h2>

          <div className="jFilters" role="tablist" aria-label="Jewellery categories">
            {categories.map((c) => (
              <button
                key={c.key}
                className={`jFilterBtn ${active === c.key ? "active" : ""}`}
                onClick={() => setActive(c.key)}
                aria-pressed={active === c.key}
                type="button"
              >
                {c.label}
              </button>
            ))}
          </div>

          <div className="jSections">
            {itemsBySection.length > 0 ? (
              <>
                {itemsBySection.map(({ secTitle, items }) => (
                  <div key={secTitle} className="jSubSection">
                    <h3 className="jSectionTitle">{secTitle}</h3>
                    <div className="jGrid">
                      {items.map(({ item, secTitle: st, czGroupTitle }) =>
                        renderCard({ item, secTitle: st, czGroupTitle })
                      )}
                    </div>
                  </div>
                ))}
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </>
            ) : (
              <p className="jEmptyState">No products in this collection yet.</p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}